import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const bookList = createAsyncThunk('books', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetAuthors = createAsyncThunk('authors', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book/get-authors`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetCategories = createAsyncThunk('categories', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book/book-categories`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const bookStore = createAsyncThunk('book-store', async (categoryData: any, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}book/store`, categoryData)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const BookCategoryStore = createAsyncThunk('store-book-cat', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}book-cat/store`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const AuthorStore = createAsyncThunk('store-author', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}author/store`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const bookEdit = createAsyncThunk('book-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const authorList = createAsyncThunk('author/list', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}author/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const authorEdit = createAsyncThunk('author/edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}author/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const categoryList = createAsyncThunk('book-cat/list', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-cat/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const categoryEdit = createAsyncThunk('book-cat/edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-cat/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const categoryBooks = createAsyncThunk('category-books', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/category-books/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetSections = createAsyncThunk('sections', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/sections`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetShelves = createAsyncThunk('shelves', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/shelves/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetEditions = createAsyncThunk('editions', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/editions`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const BookEditionStore = createAsyncThunk(
  'store-book-edition',
  async (Data: {}, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}book-edition/store`, Data)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const bookEditionList = createAsyncThunk(
  'book-edition/list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}book-edition/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const bookEditionEdit = createAsyncThunk('book-edition/edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-edition/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const SectionStore = createAsyncThunk('section-store', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}section/store`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const bookSectionList = createAsyncThunk('section/list', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}section/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const bookSectionEdit = createAsyncThunk('section/edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}section/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ShelfStore = createAsyncThunk('store-shelf', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}section/store-shelf`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const bookShelfEdit = createAsyncThunk('shelf/edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}section/edit-shelf/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LibraryStore = createAsyncThunk(
  'library-store',
  async (categoryData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}library/store`, categoryData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const libraryList = createAsyncThunk('libraries', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const libraryEdit = createAsyncThunk('book-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const bookParts = createAsyncThunk('book-parts', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-part/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const BookPartStore = createAsyncThunk('store-book-part', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}book-part/store`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const BookPartEdit = createAsyncThunk('book-part-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-part/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetParts = createAsyncThunk('library-parts', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}library/parts`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const BorrowerTypes = createAsyncThunk('borrower-types', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/borrower-types`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const BorrowerIds = createAsyncThunk('borrowers', async (id: string, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/borrowers/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LibraryBooks = createAsyncThunk('library-books', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/library-books`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const Lends = createAsyncThunk('book-lends', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/list`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LendStore = createAsyncThunk('store-book-lend', async (Data: {}, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}book-lend/store`, Data)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const LendEdit = createAsyncThunk('book-lend-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LendDelete = createAsyncThunk('book-lend-delete', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/delete/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LendView = createAsyncThunk('book-lend-view', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/view/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LendPrint = createAsyncThunk('book-lend-print', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/print/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const LendBook = createAsyncThunk('lend-book', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/lend-book/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ReceiveBook = createAsyncThunk('receive-book', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}book-lend/receive-book/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

type BookState = {
  errors: any
}

const initialState: BookState = {
  errors: '',
}

export const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(bookStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(AuthorStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(BookCategoryStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(BookEditionStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(SectionStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(ShelfStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = bookSlice.actions
export default bookSlice.reducer
